module.exports = __webpack_public_path__ + "static/media/advisor-v2.c81f4240.svg";